module.exports = __webpack_public_path__ + "static/media/noresults.394d5d33.png";